(() => {
  const rootElem = document.querySelector("html");
  const sidebar = document.querySelector(".mobile-sidebar-menu");
  if (!sidebar) return;

  const sidebarRoot = sidebar.querySelector("[data-sidebar-layer='0'][data-sidebar-page='0']");
  const sidebarRootBody = sidebarRoot.querySelector(".mobile-sidebar-menu__body");
  const searchBarContainer = sidebarRoot.querySelector(".search-bar");
  const searchBarInput = searchBarContainer.querySelector(".search-bar__input");
  const searchContainer = sidebarRoot.querySelector(".mobile-sidebar-menu__search-results");

  const sidebarRootFooter = sidebarRoot.querySelector(".mobile-sidebar-menu__footer");
  const searchBarClearInputBtn = searchBarContainer.querySelector(".search-bar__exit-button");

  const state = {
    searchActive: false,
    sidebarActive: false,
    activeLayerStack: [],
    triggerButtonStack: [],
  };

  let sidebarBackdropId = null;
  let releaseFocus = null;

  window.openSidebarNav = (switchToSearch = false) => {
    if (state.sidebarActive) return;
    ensureSidebarLayers();

    sidebar.classList.add("mobile-sidebar-menu--animated");
    sidebar.classList.add("mobile-sidebar-menu--active");
    sidebarRoot.classList.add("mobile-sidebar-menu__container--active");
    sidebar.setAttribute("aria-hidden", "false");
    sidebarRoot.setAttribute("aria-hidden", "false");

    sidebarBackdropId = window.pushBackdrop({
      hideNavbar: true,
      clickToClose: true,
      closeCallback: () => {
        sidebarBackdropId = null;
        window.closeSidebarNav();
      },
    });
    window.freezeDocumentHeight?.();
    sidebarRoot.removeAttribute("inert");

    state.sidebarActive = true;

    if (switchToSearch) openSearchView();
    else closeSearchView();
    releaseFocus = window.holdOverlayFocus(
      sidebar,
      switchToSearch ? searchBarInput : sidebarRoot.querySelector(".mobile-sidebar-menu__header-exit-button"),
      () => (state.activeLayerStack.length > 0 ? closeCurrentPanel() : window.closeSidebarNav()),
    );

    updateTriggerButtonState();
  };

  window.closeSidebarNav = () => {
    if (!state.sidebarActive) return;

    rootElem.style.overflow = "";

    for (let i = state.activeLayerStack.length - 1; i >= 0; i--) {
      const currentLayer = state.activeLayerStack[i];
      currentLayer.classList.remove("mobile-sidebar-menu__container--active");
      currentLayer.classList.remove("mobile-sidebar-menu__container--overlayed");
      currentLayer.setAttribute("aria-hidden", "true");
      currentLayer.setAttribute("inert", "true");

      const triggerButton = state.triggerButtonStack[i];
      if (triggerButton) {
        triggerButton.setAttribute("aria-expanded", "false");
      }
    }

    state.activeLayerStack = [];
    state.triggerButtonStack = [];

    sidebar.classList.remove("mobile-sidebar-menu--active");
    sidebarRoot.classList.remove("mobile-sidebar-menu__container--overlayed");
    sidebarRoot.classList.remove("mobile-sidebar-menu__container--active");

    sidebar.setAttribute("aria-hidden", "true");
    sidebarRoot.setAttribute("aria-hidden", true);
    sidebarRoot.setAttribute("inert", "true");

    state.sidebarActive = false;

    if (sidebarBackdropId !== null) {
      const id = sidebarBackdropId;
      sidebarBackdropId = null;
      window.popBackdrop(id);
    }

    window.unfreezeDocumentHeight?.();

    releaseFocus?.();
    releaseFocus = null;

    updateTriggerButtonState();
  };

  const closeCurrentPanel = () => {
    const layerIndex = state.activeLayerStack.length - 1;
    if (layerIndex < 0) {
      window.closeSidebarNav();
      return;
    }

    const currentLayer = state.activeLayerStack[state.activeLayerStack.length - 1];
    currentLayer.classList.remove("mobile-sidebar-menu__container--active");
    currentLayer.setAttribute("aria-hidden", "true");

    currentLayer.setAttribute("inert", "true");

    const triggerButton = state.triggerButtonStack.pop();
    state.activeLayerStack.pop();

    if (triggerButton) {
      triggerButton.setAttribute("aria-expanded", "false");
    }

    if (state.activeLayerStack.length > 0) {
      const newCurrentLayer = state.activeLayerStack[state.activeLayerStack.length - 1];
      newCurrentLayer.classList.remove("mobile-sidebar-menu__container--overlayed");
      newCurrentLayer.removeAttribute("inert");
    } else {
      sidebarRoot.classList.remove("mobile-sidebar-menu__container--overlayed");
      sidebarRoot.removeAttribute("inert");
    }

    if (triggerButton !== undefined) {
      triggerButton.focus();
    }
  };

  const getSidebarEntries = (rootElem, layersToCapture) => {
    const layers = new Array(layersToCapture);
    for (let i = 0; i < layers.length; i++) {
      const pagesAtLayer = rootElem.querySelectorAll(`[data-sidebar-layer='${i}']`);

      for (const p of pagesAtLayer) {
        p.style.zIndex = i;
      }

      layers[i] = Array.from(pagesAtLayer);
    }
    return layers;
  };

  const linkSidebarEntryButtons = (layers, pageElem) => {
    const onButtonClick = (button, linkLayer, linkPage) => {
      const targetPage = layers[linkLayer]?.[linkPage];
      if (!targetPage) {
        console.warn(`Page at [layer ${linkLayer}][page ${linkPage}] does not exist`);
        return;
      }

      const currentPage = state.activeLayerStack.length > 0 ? state.activeLayerStack[state.activeLayerStack.length - 1] : sidebarRoot;

      state.triggerButtonStack.push(button);
      state.activeLayerStack.push(targetPage);

      targetPage.classList.add("mobile-sidebar-menu__container--active");
      targetPage.classList.remove("mobile-sidebar-menu__container--undrawn");
      targetPage.removeAttribute("inert");
      currentPage.classList.add("mobile-sidebar-menu__container--overlayed");
      currentPage.setAttribute("inert", "true");

      button.setAttribute("aria-expanded", "true");
      targetPage.setAttribute("aria-hidden", "false");

      targetPage.querySelector(".mobile-sidebar-menu__header-close-button").focus();
    };

    const linkSingleButton = (button) => {
      const sidebarLinkLayer = button.getAttribute("data-sidebar-link-layer");
      const sidebarLinkPage = button.getAttribute("data-sidebar-link-page");

      if (sidebarLinkLayer !== null && sidebarLinkPage !== null) {
        button.addEventListener("click", () => onButtonClick(button, parseInt(sidebarLinkLayer), parseInt(sidebarLinkPage)));
      }
    };

    pageElem.querySelectorAll(".mobile-sidebar-menu__list-item-button[data-sidebar-link-layer]").forEach(linkSingleButton);

    pageElem.querySelector(".mobile-sidebar-menu__header-close-button")?.addEventListener("click", closeCurrentPanel);

    pageElem.querySelector(".mobile-sidebar-menu__header-exit-button")?.addEventListener("click", window.closeSidebarNav);
  };

  const searchManager = new SearchResultsManager(searchContainer, {
    searchResultAmount: 6,
    onPopularSearchSelect: (searchTerm) => {
      searchBarInput.value = searchTerm;
      searchManager.search(searchTerm, { debounceMs: 0 });
      searchBarClearInputBtn.classList.remove("search-bar__exit-button--hidden");
    },
  });

  const searchInputFunc = () => {
    const trimmedInput = searchBarInput.value.trim()
    trimmedInput.length > 0 ? showSearchExitBtn() : hideSearchExitBtn();
    searchManager.search(trimmedInput, { debounceMs: 500 });
  };

  const openSearchView = () => {
    sidebarRootFooter.classList.add("mobile-sidebar-menu__footer--hidden");
    sidebarRootBody.setAttribute("data-active-view", "search");
    searchBarInput.value.trim().length > 0 ? showSearchExitBtn() : hideSearchExitBtn();

    if (!state.searchActive) {
      searchManager.mount();
      state.searchActive = true;
    }

    const currentSearchValue = searchBarInput.value.trim();
    if (currentSearchValue.length <= 0) {
      searchManager.showBestSellers(false);
    } else {
      searchManager.search(currentSearchValue, { debounceMs: 0 });
    }
  };

  const closeSearchView = () => {
    if (!state.searchActive) return;
    state.searchActive = false;

    sidebarRootFooter.classList.remove("mobile-sidebar-menu__footer--hidden");
    searchBarClearInputBtn.classList.add("search-bar__exit-button--hidden");

    sidebarRootBody.setAttribute("data-active-view", "none");
    searchBarInput.value = "";
    searchBarInput.blur();
    searchManager.unmount();
  };

  const hideSearchExitBtn = () => {
    searchBarClearInputBtn.classList.add("search-bar__exit-button--hidden");
  };

  const showSearchExitBtn = () => {
    searchBarClearInputBtn.classList.remove("search-bar__exit-button--hidden");
  };

  let sidebarLayers = null;

  const startCategoryPhotos = () =>
    sidebar.querySelectorAll(".header-dropdown__group-image img").forEach((photo) => (photo.loading = "eager"));

  const ensureSidebarLayers = () => {
    if (sidebarLayers) return;
    const layersTemplate = sidebar.querySelector("#mobile-sidebar-layers");
    if (layersTemplate) {
      layersTemplate.content
        .querySelectorAll(".mobile-sidebar-menu__container")
        .forEach((menuPage) => menuPage.classList.add("mobile-sidebar-menu__container--undrawn"));
      layersTemplate.replaceWith(layersTemplate.content);
      if (document.readyState === "complete") startCategoryPhotos();
      else window.addEventListener("load", startCategoryPhotos, { once: true });
    }
    sidebarLayers = getSidebarEntries(sidebar, 3);
    sidebarLayers.flat().forEach((s) => linkSidebarEntryButtons(sidebarLayers, s));
  };
  if (window.requestIdleCallback) window.requestIdleCallback(ensureSidebarLayers, { timeout: 4000 });
  else setTimeout(ensureSidebarLayers, 2000);

  const openSidebarBtn = document.querySelector("#header-button-sidebar");

  if (openSidebarBtn) {
    openSidebarBtn.addEventListener("click", () => window.openSidebarNav(false));
    openSidebarBtn.setAttribute("aria-expanded", "false");
    openSidebarBtn.setAttribute("aria-controls", "mobile-nav-0-0");
  }

  searchBarClearInputBtn.addEventListener("click", () => {
    searchBarInput.value = "";
    searchManager.showBestSellers();
    hideSearchExitBtn();
    searchBarInput.focus()
  });

  searchBarInput.addEventListener("input", searchInputFunc);

  searchBarContainer.addEventListener("submit", (event) => {
    if (searchBarInput.value.trim().length > 0) return;
    event.preventDefault();
    searchBarInput.focus();
  });


  const updateTriggerButtonState = () => {
    if (openSidebarBtn) {
      openSidebarBtn.setAttribute("aria-expanded", state.sidebarActive ? "true" : "false");
    }
  };

  searchBarContainer.addEventListener("click", (e) => {
    if (!state.searchActive) {
      openSearchView();
    }
  });
})();
